import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { validateBase, validateLabel } from './validations.js';

export const promoteCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('promote')
    .addOption(
      new Option(
        '--base-url <url>',
        'The base url for when static files have been uploaded to an external cdn'
      )
        .argParser(validateBase)
        .hideHelp()
    )
    .addOption(
      new Option('-l, --label <label>', 'A custom label for this preview')
        .argParser(validateLabel)
        .hideHelp()
    )
    .action(async (options, command) => {
      const { baseUrl, label } = options;

      const { renderCommand } = await import('./render-command.js');

      const { PromoteCommand } = await import(
        '../components/PromoteCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <PromoteCommand baseUrl={baseUrl} label={label} />
      );
    });
};
